/**
 * Extracts the base domain from a hostname (removes subdomains).
 * e.g.: "multi01.qrcreator.com" -> "qrcreator.com"
 * e.g.: "qrcreator.com" -> "qrcreator.com"
 * e.g.: "local-app.qrcreator.com" -> "qrcreator.com"
 */
export const extractBaseDomain = (hostname: string): string => {
  if (!hostname || hostname === "localhost") {
    return hostname || "localhost";
  }

  const domainParts = hostname.split(".");
  if (domainParts.length < 2) {
    return hostname;
  }

  const lastPart = domainParts[domainParts.length - 1];
  const tldPattern = /^[a-z]{2,}$/i;

  if (tldPattern.test(lastPart)) {
    return domainParts[domainParts.length - 2] + "." + lastPart;
  }

  return hostname;
};
